<template>
  <v-card flat class="pa-0 ma-0">
    <v-card-text class="pt-4 ma-0">
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-card class="pb-3">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1">mdi-office-building-outline</v-icon
              >Company Details
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1 mt-1" justify="center">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required labelFontsize my-0"> Partner Name </label>
              <v-text-field
                class="rounded"
                dense
                v-model="partnerDetails.partner_name"
                :rules="Company_Name"
                outlined
                placeholder="Partner Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Short Name </label>
              <v-text-field
                dense
                outlined
                :rules="PartnerID"
                placeholder="Short Name"
                class="rounded"
                v-model="partnerDetails.short_code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="labelFontsize my-0"> Business License</label>
              <v-text-field
                dense
                outlined
                v-model="partnerDetails.business_license_no"
                placeholder="Business License"
                class="rounded"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Entity Type </label>
              <v-autocomplete
                dense
                outlined
                :rules="entiityrules"
                placeholder="Entity Type "
                class="rounded"
                v-model="partnerDetails.business_type"
                :items="entityType"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0">
                Nature of business</label
              >
              <v-autocomplete
                dense
                outlined
                :rules="natureofbusinessrules"
                v-model="partnerDetails.nature_of_business"
                placeholder="Nature of business"
                class="rounded"
                :items="natureofBusiness"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Country </label>
              <v-autocomplete
                class="rounded"
                dense
                v-model="partnerDetails.company_country_code"
                :items="dropdown.countryOptions"
                :disabled="disableCountry"
                :rules="CountryRules"
                item-text="text"
                item-value="value"
                outlined
                @change="getStates()"
                placeholder="Country "
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Partner Type </label>
              <v-autocomplete
                dense
                :items="partnerTypes"
                item-text="text"
                item-value="value"
                v-model="partnerDetails.partner_type"
                outlined
                :rules="PartnerType"
                placeholder="Partner Type "
                class="rounded"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" v-if="partnerDetails.partner_type === '2'">
              <label class="required labelFontsize my-0">
                Main Channel Partner
              </label>
              <v-autocomplete
                dense
                :items="main_send_partners"
                item-text="text"
                item-value="value"
                v-model="partnerDetails.main_send_partner"
                outlined
                :rules="FieldRequired('Main Channel Partner')"
                placeholder="Main Channel Partner"
                class="rounded"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Agent Type </label>
              <v-autocomplete
                dense
                :items="agentTypes"
                item-text="text"
                item-value="value"
                v-model="partnerDetails.agent_type"
                outlined
                :rules="agentType"
                placeholder="Agent Type "
                class="rounded"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> State </label>
              <v-autocomplete
                dense
                outlined
                v-model="partnerDetails.company_state"
                :rules="StateRules"
                item-text="text"
                item-value="values"
                @change="getCities(true)"
                :items="dropdown.state_options"
                placeholder="State"
                class="rounded"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <label class="labelFontsize my-0"> City </label>
              <v-autocomplete
                v-if="!cityInputEnabled"
                dense
                outlined
                v-model="partnerDetails.company_city"
                :items="dropdown.city_options"
                placeholder="City"
                class="rounded"
                item-text="text"
                item-value="values"
              >
              </v-autocomplete>
              <v-text-field
                v-else
                dense
                outlined
                v-model="partnerDetails.company_city"
                placeholder="Enter City"
                class="rounded"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> Address </label>
              <v-text-field
                dense
                outlined
                v-model="partnerDetails.company_address"
                :rules="addressValidations"
                placeholder="Address"
                class="rounded"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required labelFontsize my-0">
                Contact Number
              </label>
              <vue-phone-number-input
                :default-country-code="company_mobile_cty_code"
                v-model="partnerDetails.company_mobile"
                @update="onChangeCompanyNumber"
                class=""
                required
              />
              <small v-if="contact_error2" class="danger"
                >Contact number is required</small
              >
            </v-col>

            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0"> E-mail </label>
              <v-text-field
                dense
                :rules="emailValidations"
                v-model="partnerDetails.company_email"
                outlined
                placeholder="E-mail"
                class="rounded"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required labelFontsize my-0">
                Local Currency
              </label>
              <v-text-field
                dense
                outlined
                disabled
                placeholder="Local Currency"
                class="rounded"
                v-model="partnerDetails.local_currency"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required labelFontsize my-0"> Time Zone </label>
              <v-autocomplete
                class="rounded"
                :rules="time_zone"
                dense
                outlined
                placeholder="Time Zone"
                :items="timeZones"
                v-model="partnerDetails.time_zone"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"
                >Upload Partner Logo(Image only)
              </label>
              <v-file-input
                v-model="partnerDetails.partner_Logo"
                dense
                outlined
                ref="partnerlogo"
                class="rounded"
                accept="image/png, image/jpeg, image/bmp, image/bmp"
                placeholder="Upload Partner Logo "
                prepend-icon=""
                :rules="fileRules"
                @change="handleFileUpload(partnerDetails.partner_Logo)"
              >
                <template v-slot:append>
                  <v-btn depressed x-small icon @click="openIdlast">
                    <v-icon aria-hidden="false" color="primary">
                      mdi-cloud-upload
                    </v-icon>
                  </v-btn>
                </template>
                <template v-slot:append-outer>
                  <v-img
                    v-if="
                      partnerDetails.partner_Logo
                        ? partnerDetails.partner_Logo.value
                        : null
                    "
                    class="mt-0 pa-0"
                    max-height="40"
                    max-width="50"
                    :src="
                      partnerDetails.partner_Logo
                        ? partnerDetails.partner_Logo.value
                        : null
                    "
                    @click="
                      handleImageViewer(
                        partnerDetails.partner_Logo
                          ? partnerDetails.partner_Logo.value
                          : null,
                      )
                    "
                  />
                </template>
                <!-- <template v-slot:append-outer>
                  <v-img
                    v-if="uploadedImage"
                    :src="uploadedImage"
                    class="mt-0 pa-0"
                    max-height="40"
                    max-width="50"
                  />
                </template> -->
              </v-file-input>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <v-card class="mt-6 p-0 outlined">
                <div class="d-flex">
                  <v-sheet class="m-auto mb-2 m-2" elevation="4" width="170px">
                    <v-switch
                      label="Pin Generator"
                      v-model="partnerDetails.pin_generator"
                      color="green"
                      inset
                      dense
                      class="ms-2 mt-0 m-auto"
                      hide-details
                    ></v-switch>
                  </v-sheet>
                </div>
                <div>
                  <v-radio-group
                    v-model="partnerDetails.pin_generator_type"
                    row
                    :rules="pin_generator_type"
                    class="d-flex justify-space-around align-center m-0"
                    v-if="partnerDetails.pin_generator"
                  >
                    <v-radio
                      label="Custom"
                      color="primary"
                      value="Custom"
                      class="mt-0 m-auto"
                      inset
                      dense
                      hide-details
                    ></v-radio>
                    <v-radio
                      label="Self Partner"
                      color="primary"
                      value="Self-Partner"
                      class="mt-0 m-auto"
                      inset
                      dense
                      hide-details
                    ></v-radio>
                  </v-radio-group>

                  <div
                    class="d-flex justify-space-around labelFontsize"
                    v-if="
                      partnerDetails.pin_generator_type === 'Custom' &&
                      partnerDetails.pin_generator
                    "
                  >
                    <v-text-field
                      class="rounded px-2 labelFontsize"
                      placeholder="Prefix"
                      v-model="partnerDetails.pin_prefix"
                      :rules="pin_prefix"
                      dense
                      outlined
                    ></v-text-field>

                    <v-text-field
                      class="rounded px-2 labelFontsize"
                      placeholder="No of Digits"
                      hint="*Numeric length"
                      :rules="pin_no_of_digits"
                      dense
                      v-model="partnerDetails.pin_no_of_digits"
                      outlined
                    ></v-text-field>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="4" class="d-flex">
              <div class="d-flex">
                <v-switch
                  v-model="partnerDetails.status"
                  hide-details
                  class="labelFontsize"
                  label="Active Partner"
                ></v-switch>
              </div>
              <v-spacer></v-spacer>
            </v-col>

            <v-col cols="12" md="4" sm="4">
              <v-switch
                v-model="partnerDetails.is_head_office"
                hide-details
                class="labelFontsize ms-1"
                label="Is head office?"
              ></v-switch>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-switch
                v-model="partnerDetails.is_api_partner"
                hide-details
                class="labelFontsize ms-1"
                label="Is API partner?"
              ></v-switch>
            </v-col>
            <v-col class="ms-1 me-1 mt-1">
              <label class="labelFontsize my-0">Agent details</label>
              <v-textarea
                placeholder="Please enter Agent details"
                outlined
                :counter="counter"
                dense
                height="75px"
                v-model="partnerDetails.remarks"
                :rules="[charLimit]"
                ><template v-slot:v-counter="{ count, max }">
                  {{ count }}/{{ max }} characters entered,
                  {{ max - count }} remaining
                </template></v-textarea
              >
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1">mdi-history </v-icon>
              Business History
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1 mt-2" justify="center">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0">
                Remittance Company Name
              </label>
              <v-text-field
                class="rounded"
                dense
                outlined
                placeholder="Remittance Company Name"
                v-model="partnerDetails.previous_company_name"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> From </label>
              <v-text-field
                dense
                outlined
                placeholder="From"
                class="rounded"
                v-model="partnerDetails.previous_company_from_date"
                type="date"
                :rules="[validateFromDate]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> To </label>
              <v-text-field
                type="date"
                dense
                outlined
                placeholder="To"
                :rules="[validateToDate]"
                class="rounded"
                v-model="partnerDetails.previous_company_to_date"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-3">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1">mdi-phone</v-icon>Contact Details
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1 mt-2" justify="center">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required labelFontsize my-0"> Person Name </label>
              <v-text-field
                class="rounded"
                dense
                :rules="FullnameValidations"
                outlined
                placeholder="Contact Person Full Name"
                v-model="partnerDetails.contact_person"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0"> Contact Number </label>
              <vue-phone-number-input
                :default-country-code="contact_person_phone_cty_code"
                v-model="partnerDetails.contact_person_phone"
                @update="onChangeNumber"
                class="z-index"
              />
              <small v-if="contact_error1" class="danger"
                >Contact number is required</small
              >
            </v-col>

            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="labelFontsize my-0 required"> E-mail </label>
              <v-text-field
                dense
                outlined
                :rules="emailValidations"
                placeholder="E-mail"
                class="rounded"
                v-model="partnerDetails.contact_person_email"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ms-1 me-1 mt-1">
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required labelFontsize my-0"> Designation </label>
              <v-text-field
                dense
                outlined
                :rules="PostValidations"
                placeholder="Designation"
                class="rounded"
                v-model="partnerDetails.contact_person_post"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <span v-if="this.partnerDetails && this.partnerDetails.created_by">
          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Created By :{{
                this.partnerDetails && this.partnerDetails.created_by
                  ? this.partnerDetails.created_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Created Date :{{
                this.partnerDetails && this.partnerDetails.created_date
                  ? this.partnerDetails.created_date
                  : null
              }}</v-col
            >
          </v-row>
          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Updated By :{{
                this.partnerDetails && this.partnerDetails.modified_by
                  ? this.partnerDetails.modified_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Updated Date :{{
                this.partnerDetails && this.partnerDetails.modified_date
                  ? this.partnerDetails.modified_date
                  : null
              }}</v-col
            >
          </v-row>

          <v-row class="ms-5 mt-3 labelFontsize">
            <v-col cols="12" md="4"
              >Approved By :{{
                this.partnerDetails && this.partnerDetails.approved_by
                  ? this.partnerDetails.approved_by
                  : null
              }}</v-col
            >
            <v-col cols="12" md="4"
              >Approved Date :{{
                this.partnerDetails && this.partnerDetails.approved_date
                  ? this.partnerDetails.approved_date
                  : null
              }}</v-col
            >
          </v-row>
        </span>
        <v-col cols="12" md="12">
          <v-row class="d-flex justify-end"> </v-row>
        </v-col>
        <v-dialog persistent v-model="previewDialog" width="500">
          <v-card>
            <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
              <span class="subtitleFontsize">Preview</span>
              <v-spacer></v-spacer>
              <v-btn depressed small icon @click="previewDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-img :src="previewUrl" contain height="400"></v-img>
          </v-card>
        </v-dialog>
      </v-form>
    </v-card-text>
    <v-divider class="mb-0 pa-0"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" small @click="onClickNext()">
        Save
      </v-btn>
    </v-card-actions>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </v-card>
</template>

<script>
import alerts from "@/mixins/alerts";
import imageViewer from "@/utils/imageViewer.vue";
import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { Partnervalidations, FieldRequired } from "@/utils/validation";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService";
import handleImageUpload from "@/mixins/compressImage.mixin";
export default {
  mixins: [alerts, handleImageUpload],
  data: () => ({
    FieldRequired,
    counter: 200,
    charLimit: (v) => {
      if (v && !/^[a-z.,!@#$%^&*(){}><;'":-=_+A-Z\s]+$/.test(v)) {
        return "Only alphabetic characters are allowed";
      }
      if (/\s{2,}/.test(v)) {
        return "Spaces is not allowed";
      }
      if (v && v.length > 200) {
        return "Text must be 200 characters or less";
      } else {
        return true;
      }
    },
    ...Partnervalidations,
    // pin_generation: false,
    pinMode: "",
    isImageViewer: false,
    valid: true,
    loader: false,
    imageViewerUrl: "",
    partner_Logo: null,
    previewUrl: null,
    previewDialog: false,
    contact_error1: false,
    contact_error2: false,
    contact_person_phone_cty_code: "MY",
    company_mobile_cty_code: "MY",
    cityInputEnabled: false,
    dropdown: {
      countryOptions: [],
      state_options: [],
      city_options: [],
      country_objs: [],
    },
    disableCountry: false,
    contactformatedNumber: "",
    companyformatedNumber: "",
    payloadData: {},
    isSubmitted: false,
    number_data: null,
    errorMessage: "",
    country_options: [],
    partnerList: [],
    agentTypes: [],
    main_send_partners: [],
    natureofBusiness: [],
    entityType: [],
    partnerTypes: [],
    timeZones: [],
    isValidNumber: false,
    isValidNumber1: false,
    color: "#FF0000",
    uploadedImage: null,
    partnerDetails: {
      partner_name: "",
      short_code: "",
      company_country_code: "",
      partner_type: "",
      agent_type: "",
      business_license_no: null,
      business_type: null,
      nature_of_business: "",
      is_head_office: null,
      is_api_partner: null,
      bank_branch: "",
      previous_company_name: "",
      previous_company_from_date: null,
      previous_company_to_date: null,
      settlement_currency: "",
      company_address: "",
      license_expiry_date: null,
      company_city: "",
      company_state: "",
      company_mobile: "",
      company_mobile_cty_code: "",
      company_email: "",
      company_website: null,
      company_zip_code: null,
      local_currency: "",
      time_zone: "",
      pin_generator: false,
      pin_generator_type: "",
      pin_prefix: "",
      pin_no_of_digits: 0,
      status: false,
      contact_person: "",
      contact_person_post: "",
      contact_person_phone: "",
      contact_person_email: "",
      contact_person_phone_cty_code: "",
      partner_Logo: null,
      remarks: "",
      main_send_partner: null,
    },
  }),

  components: {
    VuePhoneNumberInput,
    imageViewer,
    Loading,
  },
  created() {},
  computed: {
    avatarSrc() {
      return this.previewUrl;
    },
  },
  mounted() {
    this.getcountryList();
    this.getdropdowntypes("AGT");
    this.getdropdowntypes("NOB");
    this.getdropdowntypes("ETD");
    this.gettimeZone();
    this.getPartnerById();
    if (this.$route.query.partner_id) {
      this.disableCountry = true;
    }
  },
  watch: {
    "partnerDetails.partner_type"(val) {
      if (val) {
        this.getmainSenderpartner();
      }
    },
    pinMode(val) {
      console.log(val);
    },
    partner_Logo() {
      this.onFileSelected();
    },
    "partnerDetails.company_country_code"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.partnerDetails.local_currency = ele.currency_code;
          this.getpartnerTypes(ele.id);
        }
      });
    },
  },

  methods: {
    handleFileUpload(data) {
      console.log("image data", data);
      if (data) {
        this.partnerDetails.partner_Logo.value = URL.createObjectURL(data);
      } else {
        this.partnerDetails.partner_Logo.value = null;
      }
      if (data.type.startsWith("image/")) {
        this.fileRules = [];
      } else {
        this.fileRules.push("Invalid image type.");
      }
    },
    validateFromDate(value) {
      // if (!value) {
      //   return "From date is required";
      // }

      if (value > new Date().toISOString().substr(0, 10)) {
        return "From date cannot be in the future";
      }

      if (value && this.partnerDetails.previous_company_to_date) {
        return (
          value <= this.partnerDetails.previous_company_to_date ||
          "From date cannot be later than To date"
        );
      }

      return true;
    },
    validateToDate(value) {
      // if (!value) {
      //   return "To date is required";
      // }

      if (value > new Date().toISOString().substr(0, 10)) {
        return "To date cannot be in the future";
      }

      if (value && this.partnerDetails.previous_company_from_date) {
        return (
          value >= this.partnerDetails.previous_company_from_date ||
          "To date cannot be earlier than From date"
        );
      }

      return true;
    },
    async getmainSenderpartner() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getmainSenderpartner({
          country_code: "MYS",
        });
        if (response.data.status_code === 200) {
          this.main_send_partners = response.data.data.map((i) => {
            return { text: i.partner_name, value: i.partner_id };
          });
          this.stoploader();
        } else {
          this.stoploader();
        }
      } catch (error) {
        this.assignedRoles = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getPartnerById() {
      const routerDataItem = this.$route.query.partner_id;
      if (routerDataItem) {
        try {
          const response = await partnerService.getPartnerById(routerDataItem);
          if (response.status === 200) {
            this.partnerList = response.data.data;
            console.log(
              "partnerDetails",
              response.data.data[0].company_country_code,
            );
            localStorage.setItem(
              "companyCountryCode",
              response.data.data[0].company_country_code,
            );
            localStorage.setItem(
              "localCurrency",
              response.data.data[0].local_currency,
            );
            console.log("response", response);
            this.partnerDetails = response.data.data[0];
            // this.partnerDetails.local_currency =
            //   response.data.data[0].settlement_currency;
            this.partnerDetails.partner_Logo = response.data.data[0]
              .upload_partner_logo
              ? {
                  name: response.data.data[0].upload_partner_logo
                    ?.split("/")
                    .pop(),
                  value: response.data.data[0].upload_partner_logo,
                }
              : null;

            this.$emit("companyDetails", this.partnerDetails);
            if (this.partnerDetails.partner_id) {
              this.contact_person_phone_cty_code =
                this.partnerDetails.contact_person_phone_cty_code;
            } else {
              this.partnerDetails.contact_person_phone_cty_code = "MY";
            }
            if (this.partnerDetails.partner_id) {
              this.company_mobile_cty_code =
                this.partnerDetails.company_mobile_cty_code;
            } else {
              this.partnerDetails.company_mobile_cty_code = "MY";
            }
          }
          // else if (response.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.getPartnerById();
          // }
          else {
            this.showAlertError(
              "Fetch Partner Data Failed: ",
              response.data.message,
            );
          }
        } catch (e) {
          this.showAlertError(
            "Fetch Partner Data Failed: Something went wrong",
          );
          console.log(e);
        }
      } else {
        console.log("partnerDetails");
      }
    },
    async submitPartner() {
      this.loader = true;
      try {
        const responseData = await partnerService.addpartnerCompany(
          this.partnerDetails,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(
            "Save Partner Data: " + responseData.data.message,
          );
          setTimeout(() => {
            this.loader = false;
          }, 200);
          this.payloadData = responseData.data.data[0];
          console.log("respose data", responseData.data.data[0].partner_id);
          this.uploadImage(responseData.data.data[0].partner_id);
          setTimeout(() => {
            this.$router.push({
              name: "Partner Summary",
              query: { partner_id: responseData.data.data[0].partner_id },
            });
          }, 300);
        } else {
          this.showAlertError(
            `Save Partner Data: ${responseData.data.message}`,
          );
          setTimeout(() => {
            this.loader = false;
          }, 200);
        }
        console.log("respose data", responseData);
      } catch (error) {
        this.showAlertError("Save Partner Data Failed: Something went wrong");
        setTimeout(() => {
          this.loader = false;
        }, 200);
        console.log(error);
      }
    },
    async update() {
      this.loader = true;
      try {
        const responseData = await partnerService.updatepartnerCompany(
          this.partnerDetails,
          this.$route.query.partner_id,
        );
        setTimeout(() => {
          this.loader = false;
        }, 200);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(
            "Update Partner Data: " + responseData.data.message,
          );
          this.uploadImage(responseData.data.data[0].partner_id);
          setTimeout(() => {
            this.$router.push({
              name: "Partner Summary",
              query: { partner_id: responseData.data.data[0].partner_id },
            });
          }, 300);
        } else {
          setTimeout(() => {
            this.loader = false;
          }, 200);
          this.showAlertError(
            "Update Partner Data: " + responseData.data.message,
          );
        }
        console.log("respose data", responseData);
      } catch (error) {
        setTimeout(() => {
          this.loader = false;
        }, 200);
        this.showAlertError("Upadte Partner Data Failed: Something went wrong");

        console.error(error);
      }
    },
    async uploadImage(id) {
      let compressdata = await this.handleImageUpload(
        this.partnerDetails.partner_Logo,
      );
      const formData = new FormData();
      formData.append("document", compressdata);

      try {
        const response = await partnerService.UploadpartnerLogo(formData, id);

        console.log(response.data);
      } catch (error) {
        console.error(error);
      }
    },

    openIdlast() {
      this.$refs.partnerlogo.$el.querySelector("input").click();
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    onClickNext() {
      !this.partnerDetails.contact_person_phone
        ? (this.contact_error1 = true)
        : (this.contact_error1 = false),
        !this.partnerDetails.company_mobile
          ? (this.contact_error2 = true)
          : (this.contact_error2 = false);
      const validate = this.$refs.complincmanual.validate();
      console.log(
        "contact",
        this.companyformatedNumber,
        this.contactformatedNumber,
      );
      if (
        validate &&
        this.contact_error1 == false &&
        this.contact_error2 == false
      ) {
        this.partnerDetails.pin_generator_type = this.partnerDetails
          .pin_generator
          ? this.partnerDetails.pin_generator_type
          : "None";
        // this.partnerDetails.company_mobile = this.companyformatedNumber;
        // this.partnerDetails.contact_person_phone = this.contactformatedNumber;
        console.log("data on click", this.partnerDetails);
        if (this.partnerDetails.partner_id) {
          this.update();
        } else {
          this.submitPartner();
        }
      }
    },
    onFileSelected() {
      const file = this.partner_Logo;
      if (!file) {
        return;
      }
      this.previewUrl = URL.createObjectURL(file); // generate a preview URL for the selected image
    },
    showPreview() {
      if (this.previewUrl) {
        this.previewDialog = true;
      }
    },
    onChangeNumber(e) {
      e ? (this.contact_error1 = false) : (this.contact_error1 = true);
      console.log("entry", e.nationalNumber);
      this.isValidNumber1 = e.isValid;
      this.partnerDetails.contact_person_phone = e.nationalNumber;
      this.partnerDetails.contact_person_phone_cty_code = e.countryCode;
    },
    onChangeCompanyNumber(e) {
      e ? (this.contact_error2 = false) : (this.contact_error2 = true);
      console.log("e", e.nationalNumber);
      this.isValidNumber = e.isValid;
      this.partnerDetails.company_mobile = e.nationalNumber;
      this.partnerDetails.company_mobile_cty_code = e.countryCode;
    },

    cancel() {
      this.$refs.complincmanual.reset();
    },

    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.dropdown.countryOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
          this.dropdown.country_objs = response.data.data;
        }
        if (this.partnerDetails.company_country_code) {
          this.getStates();
          this.dropdown.country_objs.map((ele) => {
            if (ele.iso_alpha3 === this.partnerDetails.company_country_code) {
              this.getpartnerTypes(ele.id);
            }
          });
        }

        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getStates() {
      try {
        const response = await commonService.getStatesList(
          this.partnerDetails.company_country_code,
        );
        if (response.status === 200) {
          this.dropdown.state_options = response.data.data.map((i) => {
            return { text: i.name, values: i.state_code };
          });
          if (this.partnerDetails.company_state) {
            const tempstore = this.partnerDetails.company_state;
            this.partnerDetails.company_state = tempstore;
          }
          this.getCities();
        } else {
          this.dropdown.state_options = [];
        }

        console.log("States", response);
      } catch (e) {
        this.dropdown.state_options = [];
        console.error(e);
      }
    },
    async gettimeZone() {
      try {
        const response = await commonService.gettimeZone();
        if (response.data.status_code === 200) {
          this.timeZones = response.data.data;
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.gettimeZone();
        // }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    // this.agentTypes = response.data.data.map((i) => {
    //         return { text: i.value, value: i.value_code };
    async getdropdowntypes(code) {
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "AGT":
              console.log("AGT codes", response.data.data);
              this.agentTypes = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "NOB":
              console.log("NOB codes", response.data.data);
              this.natureofBusiness = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "ETD":
              console.log("ETD codes", response);
              this.entityType = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
          }
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getdropdowntypes();
        // }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async getpartnerTypes(country_id) {
      try {
        const response = await setupService.getPartnerTypelist(country_id);
        if (response.data.status_code === 200) {
          console.log("response.data.data partner", response.data.data);
          this.partnerTypes = response.data.data[0].country_partner_list.map(
            (i) => {
              return { text: i.value, value: i.value_code };
            },
          );
          if (this.partnerDetails.partner_type) {
            const temp = this.partnerDetails.partner_type;
            this.partnerDetails.partner_type = temp;
          }
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getpartnerTypes();
        // }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async getCities(resetSelection = false) {
      if (resetSelection) this.partnerDetails.company_city = "";
      this.cityInputEnabled = false;
      this.dropdown.city_options = [];
      try {
        const response = await commonService.getCitiesList(
          this.partnerDetails.company_country_code,
          this.partnerDetails.company_state,
        );
        console.log("cities", response);
        if (response.status === 200) {
          this.dropdown.city_options = response.data.data.map((i) => {
            return { text: i.name, values: i.name, id: i.id };
          });
          this.cityInputEnabled = this.dropdown.city_options.length === 0;
          // while mapping city in text-field
          if (this.partnerDetails.company_city) {
            const tempstore = this.partnerDetails.company_city;
            this.partnerDetails.company_city = tempstore;
          }
        } else {
          this.dropdown.city_options = [];
        }
        console.log("company_city", response);
      } catch (error) {
        this.dropdown.city_options = [];
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>

<style lang="css">
.required:after {
  content: " *";
  color: red;
}
.danger {
  color: rgb(255 155 155);
  transition: 1s;
}
.v-sheet--offset {
  top: -14px;
  width: 200px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.outlined {
  border-radius: 7px;
  border: 1px solid gray;
}
.v-radio.v-label {
  margin-bottom: 0px !important;
}
.v-input--selection-controls .v-radio > .v-label {
  margin: auto !important;
}
.v-input--selection-controls__input + .v-label {
  margin: auto !important;
}
</style>
